/* nc-power – effekt i kW og HK (HK med versaler): "320 kW (435 HK)", intervaller "63–228 kW (86–310 HK)".
   Tvilling af snippets/nc-power.liquid (ret begge). Tal og enhed med hårdt mellemrum (\u00a0),
   så smalle felter kun brydes før parentesen; intervaller med ordsamler (\u2060). hk = kW × 1,35962, kW = hk ÷ 1,35962, hele tal.
   ncPower("190 hk") / ncPower("320 kW") / ncPower("40", "hk", "+") → tekst. Tekst, der ikke er
   tal + én enhed (fx "140 kW (190 HK)"), returneres uændret. Enhedsordet: window.ncPowerUnitHp || "HK". */
(function () {
  "use strict";
  var F = 1.35962;
  window.ncPower = function (value, unit, sign) {
    var raw = String(value == null ? "" : value).trim();
    var num = raw;
    sign = sign || "";
    var unitHp = window.ncPowerUnitHp || "HK";
    // Begge enheder i kilden ("90 kW / 122 hk"): samme tal, vores format.
    var both = !unit && /^(\d+)\s*kW\s*\/\s*(\d+)\s*hk$/i.exec(raw);
    if (both) return both[1] + " kW (" + both[2] + " " + unitHp + ")";
    if (!unit) {
      var m = /^(.*?)\s*(kw|bhp|hk|hp|ps)$/i.exec(raw);
      if (!m) return raw;
      num = m[1];
      unit = m[2].toLowerCase() === "kw" ? "kw" : "hk";
    }
    var parts = num.replace(/–/g, "-").split("-").map(function (p) { return p.trim(); });
    if (parts.length > 2 || parts.some(function (p) { return !/^\d+(\.\d+)?$/.test(p); })) return raw;
    var kw = [], hk = [];
    parts.forEach(function (p) {
      var n = Number(p);
      kw.push(Math.round(unit === "kw" ? n : n / F));
      hk.push(Math.round(unit === "kw" ? n * F : n));
    });
    return sign + kw.join("–\u2060") + "\u00a0kW (" + sign + hk.join("–\u2060") + "\u00a0" + unitHp + ")";
  };
})();
